import { render, staticRenderFns } from "./CreateVirtualDataForm.vue?vue&type=template&id=d2163f4c"
import script from "./CreateVirtualDataForm.vue?vue&type=script&lang=js"
export * from "./CreateVirtualDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports